import React, { useState } from "react";
import { supabase } from "../../lib/supabaseClient";

export default function QuickCreateFairForm() {
  const [nom, setNom] = useState("");
  const [ville, setVille] = useState("");
  const [pays, setPays] = useState("");
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [source, setSource] = useState("");
  const [msg, setMsg] = useState("");

  async function save(e){
    e.preventDefault();
    setMsg("Enregistrement…");
    const { error } = await supabase.rpc("fn_upsert_fair", {
      p_id: null,
      p_nom: nom || null,
      p_ville: ville || null,
      p_pays: pays || null,
      p_date_debut: dateDebut || null,
      p_date_fin: dateFin || null,
      p_source: source || null
    });
    setMsg(error ? ("❌ "+error.message) : "✅ Foire enregistrée");
    if (!error) { setNom(""); setVille(""); setPays(""); setDateDebut(""); setDateFin(""); setSource(""); }
  }

  return (
    <form onSubmit={save} className="space-y-3">
      <input className="border rounded px-3 py-2 w-full" placeholder="Nom de la foire" value={nom} onChange={e=>setNom(e.target.value)} required />
      <div className="grid grid-cols-3 gap-3">
        <input className="border rounded px-3 py-2" placeholder="Ville" value={ville} onChange={e=>setVille(e.target.value)} />
        <input className="border rounded px-3 py-2" placeholder="Pays" value={pays} onChange={e=>setPays(e.target.value)} />
        <input className="border rounded px-3 py-2" placeholder="Source (site)" value={source} onChange={e=>setSource(e.target.value)} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <input type="date" className="border rounded px-3 py-2" value={dateDebut} onChange={e=>setDateDebut(e.target.value)} />
        <input type="date" className="border rounded px-3 py-2" value={dateFin} onChange={e=>setDateFin(e.target.value)} />
      </div>
      <div className="flex gap-2">
        <button className="px-4 py-2 rounded bg-black text-white">Enregistrer</button>
        {msg && <div className="text-sm text-gray-600">{msg}</div>}
      </div>
    </form>
  );
}
